import config from "./config";
var axios = config();

export default {
  getTranslationalTeam(id) {
    return axios.get("/api/TranslationalTeams/GetTranslationalTeamById", {
      params: { id: id }
    });
  },

  getTranslationalTeams() {
    return axios.get("/api/TranslationalTeams/GetActiveTranslationalTeams", {
      params: {}
    });
  },

  postTranslationalTeam(translationalTeam) {
    return axios.post(
      "/api/TranslationalTeams/AddTranslationalTeam",
      translationalTeam
    );
  },

  postEditTranslationalTeam(translationalTeam) {
    return axios.post(
      "/api/TranslationalTeams/EditTranslationalTeam",
      translationalTeam
    );
  }
};
